module.exports = __webpack_public_path__ + "img/close.a594ab60.svg";